window.TeamAPI = new function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    var url = environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? publicConfiguration.TSTeamServerBaseURL : publicConfiguration.TeamServerBaseURL;
    _protected.setApiUrl(url);

    /**
     * get team users.
     * @param userId
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.getUsers = function (brandId, params, method) {
        method = method || "GET";
        var deferred = $q.defer();
        _protected.request("brands/"+ brandId +"/users/search", method, params
        ).then(function (res) {
            if (res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    self.getBrandUsers = function (brandId, params) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/users/search", "POST", params)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    /**
     * Resends activation email to the employees
     * @param userId
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.reSendEmployeeActivationEmail = function (brandId, userId) {

        _protected.request("brands/" + brandId + "/users/" + userId + "/profile/activation/resend", "POST", {})
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });
        var deferred = $q.defer();
        return deferred.promise;
    };
    /**
     * gets the details of the member
     * @param member
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.getMemberDetails = function (brandId, userId, requiredData) {

        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v3') + "brands/" + brandId + "/users", "GET", {required_data: requiredData || "detailed" , user_ids: userId})
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getAllAdmins = (brandId) => {
        let defer = $q.defer();
        _protected.request( `brands/${brandId}/admins/users`, "GET")
            .then((res) => {
                if (res?.data?.data && res.status === 200) {
                    defer.resolve(res.data.data.users || []);
                } else {
                    defer.reject(res);
                }
            })
            .catch((err) => {
                defer.reject(err);
            });
        return defer.promise;
    };

    /**
     * Get a list of all the employees that we could import to the team schedule
     * @param brandId
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.getBrandEmployees = function (brandId, userStatus, schedulable) {

        var deferred = $q.defer();

        var params = {
            view: userStatus || 'ACTIVE'
        };

        if (schedulable) {
            params['schedulable'] = schedulable;
        }

        _protected.request(self.apiUrl.replace('v1', 'v3') + "brands/" + brandId + "/users", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        _protected.setApiUrl(url);

        return deferred.promise;
    };

    self.getBusinessUsers = function (brandId, employeesIds, employersIds) {
        var deferred = $q.defer();
        var params = {};

        if (employeesIds.length > 0) {
            params['employees_ids'] = employeesIds.join(',');
        }

        if (employersIds.length > 0) {
            params['employers_ids'] = employersIds.join(',');
        }

        _protected.request( "businesses/" + brandId + "/users", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        _protected.setApiUrl(url);

        return deferred.promise;
    };

    /**
     * Send employees to the team schedule
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.sendEmployeesToSchedule = function (brandId, employeeIds) {

        var deferred = $q.defer();

        var params = {
            employees: employeeIds
        };

        _protected.request("brands/" + brandId + "/team_schedule", "PUT", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    /**
     * Create team schedule user
     * @param member
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.createTeamScheduleMember = function (brandId, member) {

        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/team_schedule", "POST", member)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    /**
     * Export Brand Users or Brand User Positions
     * @param brandId
     * @param mode , category , extension , export_channel
     */
    self.exportTeamUsers = function (brandId, mode, category, extension, export_channel) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }
        var payloaod = {
            mode: mode,
            category: category, extension: extension,
            export_channel: export_channel
        };

        _protected.request("brands/" + brandId + "/users/export", "POST", payloaod)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getBrandNotificationSubscribers = function (brandId, reportType) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/users/notifications/" + reportType, "GET")
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    deferred.resolve(res.data.data.subscribers || []);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getEmployeeJobTitles = function (brandId, userId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/users/" + userId + "/job_titles", "GET")
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data.user_brand_job_titles || []);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getEmployeeWithExtraPayStation = async (brandId, limit, jobTitles) => {
        let params = {
            limit: limit,
            brand_job_title_ids: jobTitles.join(',')
        }

        const res = await _protected.request(`brands/${brandId}/job_titles/extra_pays/users`, 'GET', params);

        if (res.status === 200 && res.data?.data) {
            return res.data.data;
        } else {
            throw res;
        }
    };

    self.updateEmployeeJobTitles = function (brandId, userId, userJobTitles) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/users/" + userId + "/job_titles", "PUT", {user_brand_job_titles: userJobTitles})
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getBrandJobTitles = function (brandId) {
        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + "brands/" + brandId + "/job_titles", "GET")
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data.job_titles || []);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getAllUsersJobTitles = (brandId, startDate, endDate) => {
        var deferred = $q.defer();

        const params =
            (startDate && endDate) ? {
                start_date: startDate,
                end_date: endDate
            } : null;

        _protected.request(`brands/${brandId}/users/job_titles`, "GET", params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data.users || []);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.checkIfBrandsHasAnonymousUsers = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/users/check_anonymity", "POST", payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data.brands || []);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getBrandJobTitlesForEmployee = function (brandId) {
        var deferred = $q.defer();

        _protected.request("employees/brands/" + brandId + "/job_titles", "GET")
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data.job_titles || []);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.saveBrandNotificationSubscribers = function (brandId, reportType, usersIds) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/users/notifications/" + reportType, "PUT", {subscribers: usersIds || []})
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    /**
     * Get all the team members who are on team schedule for this brand
     * @param brandId
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.getTeamMembers = function (brandId, userIds, userStatus, schedulable, requiredData) {
        var deferred = $q.defer();
        var params = {};

        if (userIds && userIds.length) {
            var filteredArray = userIds.filter(function (item) {
                return item;
            });
            if (filteredArray.length) {
                params.user_ids = filteredArray.join()
            }
        }

        if (userStatus) {
            params['view'] = userStatus;
        }

        if (schedulable) {
            params['schedulable'] = schedulable;
        }

        if (requiredData) {
            params['required_data'] = requiredData;
        }

        _protected.request(self.apiUrl.replace('v1', 'v3') + "brands/" + brandId + "/users", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getHarriBrandEmployees = function (brandId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/harri_users", "GET", {})
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    /**
     * Get all the team schedule brands for employee ( team.live )
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.getEmployeeBrands = function () {
        var deferred = $q.defer();
        _protected.request('brands', "GET", {})
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };


    /**check User Email
     * Get all the team schedule brands
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.checkUserEmail = function (groupId, emails) {
        var deferred = $q.defer();
        var params = {
            emails: emails,
            is_scheduling_member : true
        };

        _protected.request("groups/" + groupId + "/brands/users", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.checkUserPhone = function (groupId, phones) {
        var deferred = $q.defer();
        var params = {
            phones: phones,
            is_scheduling_member: true
        };

        _protected.request("groups/" + groupId + "/brands/users", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    /**
     * Deactivate member from brand
     * @param brandId
     * @param memberId
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.deactivateMember = function (brandId, memberId) {

        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/users/" + memberId + "/deactivate", "PUT", {})
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    /**
     * Sets the default brand for this user
     * @param brandId
     * @param userId
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.setDefaultBrand = function (brandId) {

        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/users", "PUT", {is_default: true})
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.updateUserInfo = function (data) {
        var deferred = $q.defer();

        _protected.request("users", "PUT", data)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.updatePassword = function (oldPass, newPass) {
        var deferred = $q.defer();

        _protected.request("change_password", "PUT", {old_password: oldPass, new_password: newPass})
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getMemberBasicInfo = function (brandId, userId) {

        var deferred = $q.defer();

        if (!brandId || !userId) {
            deferred.reject("Can't request the API");
            return deferred.promise;
        }

        _protected.request("brands/" + brandId + "/users/" + userId + "/basic_info", "GET", {})
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getMemberContactInfo = function (brandId, userId) {

        var deferred = $q.defer();

        if (!brandId || !userId) {
            deferred.reject("Can't request the API");
            return deferred.promise;
        }

        _protected.request("brands/" + brandId + "/users/" + userId + "/contact_info", "GET", {})
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.updateMemberContactInfo = function (brandId, userId, contactInfo) {

        var deferred = $q.defer();

        if (!brandId || !userId) {
            deferred.reject("Can't request the API");
            return deferred.promise;
        }

        _protected.request("brands/" + brandId + "/users/" + userId, "PUT", contactInfo)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getMemberRoles = function (brandId, userId) {

        var deferred = $q.defer();

        if (!brandId || !userId) {
            deferred.reject("Can't request the API");
            return deferred.promise;
        }

        _protected.request("brands/" + brandId + "/users/" + userId + "/roles", "GET", {})
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    /**
     * Creates a role for the member
     * @param brandId
     * @param memberId
     * @param roles Array
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.saveMemberRoles = function (brandId, memberId, data) {

        var deferred = $q.defer();

        if (!brandId || !memberId) {
            deferred.reject("Can't request the API");
            return deferred.promise;
        }

        _protected.request("brands/" + brandId + "/users/" + memberId + "/roles", "PUT", {
            roles: data.roles,
            max_weekly_hours: data.max_weekly_hours,
            hire_date: data.hire_date
        })
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    /**
     * get brand schedule with roles and their costs
     * @param brandId
     * @param startDay
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.getBrandScheduleCosts = function (brandId, startDay, useCache) {
        var deferred = $q.defer();

        var params = {};

        params['start_date'] = startDay;

        var requestIdentifier = brandId + JSON.stringify(params);
        var cached = _protected.getCached(requestIdentifier);

        if (cached) {
            deferred.resolve(cached);
            return deferred.promise;
        }

        _protected.request("brands/" + brandId + "/team_schedule", "GET", params)
            .then(function (res) {

                if (res.data && res.data.status_code == 200 && res.data.data) {
                    if (useCache) {
                        _protected.cache(requestIdentifier, res.data.data || []);
                    }

                    deferred.resolve(res.data.data || []);
                } else {
                    deferred.reject(res);
                }
            });

        return deferred.promise;
    };

    /**
     * get brand schedule with roles and their costs
     * @param brandId
     * @param startDay
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.getBrandScheduleCostsV2 = function (brandId, startDay, useCache) {
        var deferred = $q.defer();

        var params = {};

        params['start_date'] = startDay;

        var requestIdentifier = brandId + JSON.stringify(params);
        var cached = _protected.getCached(requestIdentifier);

        if (cached) {
            deferred.resolve(cached);
            return deferred.promise;
        }

        var spreadPeriodToDates = function (periods, oldKey) {
            if (!periods) {
                return periods;
            }

            var result = [];

            for (var i in periods) {
                var period = periods[i];
                var fromDate = moment(period['from_date']);
                var toDate = moment(period['to_date']);

                delete period['from_date'];
                delete period['to_date'];

                while (fromDate.isSameOrBefore(toDate)) {
                    var newPeriod = angular.copy(period);

                    newPeriod['date'] = fromDate.format("MMM DD, YYYY");

                    if (oldKey) {
                        newPeriod[oldKey] = newPeriod['value'];
                        delete newPeriod['value'];
                    }

                    result.push(newPeriod);
                    fromDate.add(1, 'day');
                }
            }

            return result;
        };

        _protected.request(self.apiUrl.replace('v1', 'v2') + "brands/" + brandId + "/team_schedule", "GET", params)
            .then(function (res) {

                if (res.data && res.data.status_code == 200 && res.data.data) {

                    if (!res.data.data.processed) {
                        res.data.data.processed = true;

                        for (var i in res.data.data['users']) {
                            var userData = res.data.data['users'][i];
                            userData['pay_type'] = spreadPeriodToDates(userData['pay_type'], 'type');
                            userData['annual_rate'] = spreadPeriodToDates(userData['annual_rate']);
                            userData['primary_brands'] = spreadPeriodToDates(userData['primary_brands'], 'brand_id');
                            userData['ni'] = spreadPeriodToDates(userData['ni']);
                            userData['pension'] = spreadPeriodToDates(userData['pension']);
                            userData['additional_costs'] = spreadPeriodToDates(userData['additional_costs']);
                            userData['shifts_per_week'] = spreadPeriodToDates(userData['shifts_per_week']);
                            userData['max_weekly_hours'] = spreadPeriodToDates(userData['max_weekly_hours']);
                            userData['tronc'] = spreadPeriodToDates(userData['tronc']);
                            userData['work_limit_responses'] = spreadPeriodToDates(userData['work_limit_responses']);
                            userData['extra_pays'] = spreadPeriodToDates(userData['extra_pays']);

                            if (userData['pay_type']) {
                                for (var j in userData['pay_type']) {
                                    userData['pay_type'][j]['annual_rate'] = spreadPeriodToDates(userData['pay_type'][j]['annual_rate']);
                                }
                            }

                            if (userData['positions']) {
                                for (var j in userData['positions']) {
                                    userData['positions'][j]['pay_rates'] = spreadPeriodToDates(userData['positions'][j]['pay_rates']);
                                    userData['positions'][j]['is_tipped_ranges'] = spreadPeriodToDates(userData['positions'][j]['is_tipped_ranges']);
                                }
                            }
                        }
                    }

                    if (useCache) {
                        _protected.cache(requestIdentifier, res.data.data || []);
                    }

                    deferred.resolve(res.data.data || []);
                } else {
                    deferred.reject(res);
                }
            });

        return deferred.promise;
    };

    /**
     * gets the details of the logged in member from employee side
     *
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.getUserDetails = function () {

        var deferred = $q.defer();

        _protected.request("users", "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    //Brand active categories / Get Brand active position categories
    self.getBrandActivePositionCategories = function (brandId, includePosition, includeChildren, includeDeleted, includeDeactivated, isEmployee) {
        var deferred = $q.defer();
        var params = {};

        if (includePosition) {
            params['include_position'] = true;
        }

        if (includeChildren) {
            params['include_children_brands'] = true;
        }

        if (includeDeleted) {
            params['include_deleted_positions'] = true;
        }

        if (includeDeactivated) {
            params['include_deactivated_users'] = true;
        }

        var url = "brands/" + brandId + "/positions/categories";

        if (isEmployee) {
            url = 'employees/' + url;
        }

        _protected.request(url , "GET", params)
            .then(function (res) {
                    if (res.data && res.data.status_code == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    //get Brand users roles
    self.getBrandRoles = function (brandId, params, type) {
        var deferred = $q.defer();

        if (!type) {
            type = "";
        } else {
            type = '/' + type;
        }

        _protected.request("brands/" + brandId + "/users/roles" + type, "GET", params)
            .then(function (res) {
                    if (res.status === 200 && res.data && res.data.data) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.addBrandRoles = function (brandId, payload, type) {
        var deferred = $q.defer();
        var urlTypeParameter = "";

        if (!type) {
            type = "";
        } else {
            type = '/' + type;
        }

        _protected.request("brands/" + brandId + "/users/roles" + type, "PUT", payload)
            .then(function (res) {
                    if (res.status === 200 && res.data && res.data.data) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    //get brand users privileges
    self.getBrandUsersPrivileges = function (brandId, type) {
        var deferred = $q.defer();

        var params = {};
        if (type) {
            params.type = type;
        }

        _protected.request("brands/" + brandId + "/users/privileges", "GET", params)
            .then(function (res) {
                    if (res.status === 200 && res.data && res.data.data) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.updateBrandUsersPrivileges = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/users/privileges", "PUT", payload)
            .then(function (res) {
                    if (res.data && res.data.status_code == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getBrandActiveCategoriesPosition = function (brandId, payType) {
        var deferred = $q.defer();

        var params = {
            pay_type: payType
        };

        _protected.request("brands/" + brandId + "/categories/positions", "GET", params)
            .then(function (res) {
                    if (res.data && res.data.status_code == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getPayrollCodeRates = function (brandId, userId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/users/" + userId + "/payroll", "GET")
            .then(function (res) {
                    if (res.data && res.data.status_code == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.managePayrollCodeRates = function (brandId, userId, payrollCodes, payrollId, posRef) {
        var deferred = $q.defer();

        var payload = {
            pay_rate_codes: payrollCodes,
            payroll_id: payrollId,
            point_of_sale_reference_id: posRef
        };

        _protected.request("brands/" + brandId + "/users/" + userId + "/payroll", "PUT", payload)
            .then(function (res) {
                    if (res.data && res.data.status_code == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    //Employer Privileged postions and categories / Get Privileged postions and categories
    self.getEmployerPrivilegedPostionsAndCategories = function (brandId, permissionCheckType) {
        var deferred = $q.defer();
        var params = {
            type: permissionCheckType
        };

        _protected.request("brands/" + brandId + "/categories/positions", "GET", params)
            .then(function (res) {
                    if (res.status === 200 && res.data && res.data.data) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    //Privileged active employees / Get Privileged active employees
    self.getEmployerPrivilegedActiveEmployees = function (brandId, type, date) {
        var deferred = $q.defer();

        var params = {
            type: type,
            date: date
        };

        _protected.request("brands/" + brandId + "/privileges/employees", "GET", params)
            .then(function (res) {
                    if (res.status === 200 && res.data && res.data.data) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.resendPINCode = function (brandId, userId) {

        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/users/" + userId + "/profile/pin/resend", "POST", {})
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getEmployeeActiveLocations = function (groupId, userId) {

        var deferred = $q.defer();

        if (!groupId) {
            throw "No group id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request("groups/" + groupId + "/users/" + userId + "/brands", "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateEmployeeActiveLocations = function (groupId, userId, locations) {

        var deferred = $q.defer();

        if (!groupId) {
            throw "No group id";
        }

        if (!userId) {
            throw "No user id";
        }

        var payload = {
            brands: locations
        };


        _protected.request("groups/" + groupId + "/users/" + userId + "/brands", "PUT", payload)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getEmployeeUnassignedLocations = function (brandId, userId) {

        var deferred = $q.defer();

        _protected.request(`brands/${brandId}/users/${userId}/locations/unassigned`, "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data.brands);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.syncWithPayroll = function (brandId, user_id, payroll, type) {

        var deferred = $q.defer();
        var apiURL = "brands/" + brandId + "/channels/" + payroll + "/users/" + user_id + "/sync";

        var payload = {
            'out_of_sync_sections': [type]
        };
        _protected.request(apiURL, 'POST', payload)
            .then(function (result) {
                if (result && result.status == 200 && result.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result.data.status);
                }
            }, function (err) {

                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getBrandUserAuditLog = function (brandId, user_id) {

        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/users/" + user_id + "/logs", 'GET')
            .then(function (result) {
                if (result && result.status == 200 && result.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data.logs);
                } else {
                    deferred.reject(result.data.status);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandNICategories = function (brandId, countryCode, startDate) {

        var deferred = $q.defer();

        /**
         * E.g. country_code=UK&start_date=2017-12-28
         * @type {{country_code: String, start_date: String}}
         */
        var payload = {
            country_code: countryCode,
            start_date: startDate
        };

        _protected.request("brands/" + brandId + "/ni_categories", "GET", payload)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data.settings);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };




    self.getBrandUserLogs = function (brandId, userId, groups) {
        var deferred = $q.defer();
        if (groups && Array.isArray(groups)) {
            groups = groups.join(',');
        }

        var params = {
            groups: groups
        };

        _protected.request("brands/" + brandId + "/users/" + userId + "/audit_logs", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data.logs);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.getEmployeeInfo = function (brandId, userId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw new Error("No brand id");
        }

        if (!userId) {
            throw new Error("No user id");
        }

        _protected.request(self.apiUrl.replace('v1', 'v3') + "brands/" + brandId + "/users/" + userId, "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateEmployeeInfo = function (brandId, userId, payload) {
        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + "brands/" + brandId + "/users/" + userId, "PUT", payload)
            .then(function (res) {
                    if (res.data && res.data.status_code == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.updateEmployeeTeamHubInfo = function (brandId, userId, payload) {
        var deferred = $q.defer();

        _protected.request( "brands/" + brandId + "/users/" + userId + "/is_meal_participant", "PUT", payload)
            .then(function (res) {
                    if (res.data && res.data.status_code == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getEmployeePositionsInfo = function (brandId, userId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request(self.apiUrl.replace('v1', 'v2') +'brands/' + brandId + '/users/' + userId + '/positions', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateEmployeePositionsInfo = function (brandId, userId, positions) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        var payload = {
            positions: positions
        };

        _protected.request(self.apiUrl.replace('v1', 'v2') + self.apiUrl.replace('v1', 'v2') + 'brands/' + brandId + '/users/' + userId + '/positions', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getEmployeeNIPensionInfo = function (brandId, userId, includeDeleted, category) {

        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!category) {
            throw "NI or Pension must be provided";
        }

        var params = {
            include_deleted: includeDeleted || false
        };

        _protected.request('brands/' + brandId + '/users/' + userId + '/' + category, 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateEmployeeNIPensionInfo = function (brandId, userId, category, recordId, payload) {

        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!category) {
            throw "No category";
        }

        if (!recordId) {
            throw "No record id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/' + category + '/' + recordId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createEmployeeNIPensionInfo = function (brandId, userId, category, payload) {

        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!category) {
            throw "No category";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/' + category, 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteEmployeeNIPensionInfo = function (brandId, userId, category, recordId) {

        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!category) {
            throw "No category";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/' + category + '/' + recordId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getEmployeeAdditionalCostsInfo = function (brandId, userId, includeDeleted) {

        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        var params = {
            include_deleted: includeDeleted || false
        };

        _protected.request('brands/' + brandId + '/users/' + userId + '/additional_costs', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateEmployeeAdditionalCostsInfo = function (brandId, userId, recordId, payload) {

        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!recordId) {
            throw "No record id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/additional_costs/' + '/' + recordId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createEmployeeAdditionalCostsInfo = function (brandId, userId, payload) {

        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/additional_costs', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteEmployeeAdditionalCostsInfo = function (brandId, userId, recordId) {

        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/additional_costs/' + recordId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createPayTypesInformation = function (brandId, userId, payload, headers) {
        var deferred = $q.defer();
        headers ??= {};

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.requestWithHeaders('brands/' + brandId + '/users/' + userId + '/pay_types', 'POST', payload, headers)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updatePayTypesInformation = function (brandId, userId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        var payTypeId = payload.id;

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deletePayTypesInformation = function (brandId, userId, payTypesId, headers) {
        var deferred = $q.defer();
        headers ??= {};

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.requestWithHeaders('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypesId, 'DELETE', {}, headers)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createMaxWeeklyHours = function (brandId, userId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/max_weekly_hours', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateMaxWeeklyHours = function (brandId, userId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        var maxWeeklyHoursId = payload.id;

        _protected.request('brands/' + brandId + '/users/' + userId + '/max_weekly_hours/' + maxWeeklyHoursId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteMaxWeeklyHours = function (brandId, userId, maxWeeklyHoursId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/max_weekly_hours/' + maxWeeklyHoursId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createTroncs = function (brandId, userId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/troncs', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateTroncs = function (brandId, userId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        var troncId = payload.id;

        _protected.request('brands/' + brandId + '/users/' + userId + '/troncs/' + troncId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteTroncs = function (brandId, userId, troncId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/troncs/' + troncId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createShiftsPerWeeks = function (brandId, userId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/shifts_per_weeks', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateShiftsPerWeeks = function (brandId, userId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        var ShiftsPerWeeksId = payload.id;

        _protected.request('brands/' + brandId + '/users/' + userId + '/shifts_per_weeks/' + ShiftsPerWeeksId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteShiftsPerWeeks = function (brandId, userId, shiftsPerWeeksId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/shifts_per_weeks/' + shiftsPerWeeksId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createPayRates = function (brandId, userId, positionCode, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/positions/' + encodeURIComponent(encodeURIComponent(positionCode)) + '/pay_rates', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updatePayRates = function (brandId, userId, positionCode, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        var payRatesId = payload.id;

        _protected.request('brands/' + brandId + '/users/' + userId + '/positions/' + encodeURIComponent(encodeURIComponent(positionCode)) + '/pay_rates/' + payRatesId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deletePayRates = function (brandId, userId, positionCode, payRatesId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/positions/' + encodeURIComponent(encodeURIComponent(positionCode)) + '/pay_rates/' + payRatesId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createTipped = function (brandId, userId, positionCode, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/positions/' + encodeURIComponent(encodeURIComponent(positionCode)) + '/tipped', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateTipped = function (brandId, userId, positionCode, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        var tippedId = payload.id;

        _protected.request('brands/' + brandId + '/users/' + userId + '/positions/' + encodeURIComponent(encodeURIComponent(positionCode)) + '/tipped/' + tippedId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteTipped = function (brandId, userId, positionCode, tippedId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/positions/' + encodeURIComponent(encodeURIComponent(positionCode)) + '/tipped/' + tippedId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserStationsExtraPays = async (brandId, userId, params) => {
        const response = await _protected.request(`brands/${brandId}/users/${userId}/job_titles/extra_pays`, "GET", params);
        if (response.status === 200 && response.data?.data) {
            return response.data.data.extra_pays || [];
        } else {
            throw response;
        }
    };

    self.createAnnualRates = function (brandId, userId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/annual_rates', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateAnnualRates = function (brandId, userId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        var annualRatesId = payload.id;

        _protected.request('brands/' + brandId + '/users/' + userId + '/annual_rates/' + annualRatesId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteAnnualRates = function (brandId, userId, annualRatesId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/annual_rates/' + annualRatesId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * TLUK2 wages API
     */

    self.getCurrentActiveFinancials = function (brandId, userId, mode) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        var payload = {
            mode: mode
        };

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'brands/' + brandId + '/users/' + userId + '/financials', 'GET', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.editUserPayType = function (brandId, userId, payTypeId, payload, headers) {
        var deferred = $q.defer();
        headers ??= {};

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!payTypeId) {
            throw "No pay type id";
        }

        _protected.requestWithHeaders('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId, 'PUT', payload, headers)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deletePosition = function (brandId, userId, positionCode) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/positions/' + encodeURIComponent(encodeURIComponent(positionCode)), 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.editPositionCostCenter = function (brandId, userId, positionCode, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'brands/' + brandId + '/users/' + userId + '/positions/' + encodeURIComponent(encodeURIComponent(positionCode)), 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getWageRuleRates = function (brandId, userId, params) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request(`brands/${brandId}/users/${userId}/wage_rule_rates`, 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data.wage_rule_rates);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserPayTypes = function (brandId, userId, includeDeleted) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        var params = {
            include_deleted: includeDeleted
        };

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserMaxWeeklyHours = function (brandId, userId, payTypeId, includeDeleted) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!payTypeId) {
            throw "No user id";
        }

        var params = {
            include_deleted: includeDeleted
        };

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/max_weekly_hours', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserShiftsPerWeeks = function (brandId, userId, payTypeId, includeDeleted) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!payTypeId) {
            throw "No user id";
        }

        var params = {
            include_deleted: includeDeleted
        };

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/shifts_per_weeks', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserAnnualRate = function (brandId, userId, payTypeId, includeDeleted) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!payTypeId) {
            throw "No user id";
        }

        var params = {
            include_deleted: includeDeleted
        };

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/annual_rates', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserTroncs = function (brandId, userId, payTypeId, includeDeleted) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!payTypeId) {
            throw "No user id";
        }

        var params = {
            include_deleted: includeDeleted
        };

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/troncs', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createUserMaxWeeklyHours = function (brandId, userId, payTypeId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/max_weekly_hours', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.editUserMaxWeeklyHours = function (brandId, userId, payTypeId, maxWeeklyHoursId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/max_weekly_hours/' + maxWeeklyHoursId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteUserMaxWeeklyHours = function (brandId, userId, payTypeId, maxWeeklyHoursId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/max_weekly_hours/' + maxWeeklyHoursId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createUserAnnualRate = function (brandId, userId, payTypeId, payload, headers) {
        var deferred = $q.defer();
        headers ??= {};

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.requestWithHeaders('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/annual_rates', 'POST', payload, headers)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.editUserAnnualRate = function (brandId, userId, payTypeId, annualRateId, payload, headers) {
        var deferred = $q.defer();
        headers ??= {};

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.requestWithHeaders('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/annual_rates/' + annualRateId, 'PUT', payload, headers)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteUserAnnualRate = function (brandId, userId, payTypeId, annualRateId, headers) {
        var deferred = $q.defer();
        headers ??= {};

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.requestWithHeaders('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/annual_rates/' + annualRateId, 'DELETE', {}, headers)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createUserTronc = function (brandId, userId, payTypeId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/troncs', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.editUserTronc = function (brandId, userId, payTypeId, troncId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/troncs/' + troncId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteUserTronc = function (brandId, userId, payTypeId, troncId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/troncs/' + troncId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createUserShiftsPerWeek = function (brandId, userId, payTypeId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/shifts_per_weeks', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.editUserShiftsPerWeek = function (brandId, userId, payTypeId, shiftsPerWeekId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/shifts_per_weeks/' + shiftsPerWeekId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteUserShiftsPerWeek = function (brandId, userId, payTypeId, shiftsPerWeekId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/shifts_per_weeks/' + shiftsPerWeekId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createHourlyPosition = function (brandId, userId, payTypeId, payload, headers) {
        var deferred = $q.defer();
        headers ??= {};

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!payTypeId) {
            throw "No pay type id";
        }

        _protected.requestWithHeaders(self.apiUrl.replace('v1', 'v2') + 'brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/positions', 'POST', payload, headers)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createPositionOutOfPayType = function (brandId, userId, payload) {

        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'brands/' + brandId + '/users/' + userId + '/positions', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createUserTipped = function (brandId, userId, payTypeId, positionCode, payload) {

        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!payTypeId) {
            throw "No pay type id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/positions/' + encodeURIComponent(encodeURIComponent(positionCode)) + '/tipped', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserTipped = function (brandId, userId, payTypeId, positionCode, includeDeleted) {

        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!payTypeId) {
            throw "No pay type id";
        }

        var params = {
            include_deleted: includeDeleted
        };

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/positions/' + encodeURIComponent(encodeURIComponent(positionCode)) + '/tipped', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.editUserTipped = function (brandId, userId, payTypeId, positionCode, tippedId, payload) {

        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!payTypeId) {
            throw "No pay type id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/positions/' + encodeURIComponent(encodeURIComponent(positionCode)) + '/tipped/' + tippedId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getFinancialUnitsThatIncludeGroups = function (brandId, groupsType) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "no brandId!";
        }

        var params = {
            group_type: groupsType
        };

        _protected.request("brands/" + brandId + "/settings/financial_unit_groups/financial_unit_brands", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getGroupLocationsList = function (brandId, groupId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "no brandId!";
        }

        _protected.request("brands/" + brandId + "/settings/financial_unit_groups/" + groupId + "/locations", "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getFinancialUnitGroups = function (brandId, groupsType) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "no brandId!";
        }

        var params = {
            group_type: groupsType
        };

        _protected.request("brands/" + brandId + "/settings/financial_unit_groups", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.validateCreatingShareTransferGroup = function (brandId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw 'no brandId!';
        }

        _protected.request("brands/" + brandId + "/settings/financial_unit_groups/validate", "POST", payload)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.validateUpdatingShareTransferGroup = function (brandId, groupId, payload) {
        var deferred = $q.defer();

        if (!brandId || !groupId) {
            throw !brandId ? 'no brandId!' : 'no groupId!';
        }

        _protected.request("brands/" + brandId + "/settings/financial_unit_groups/" + groupId + "/validate", "POST", payload)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.validateDeletingShareTransferGroup = function (brandId, groupId) {
        var deferred = $q.defer();

        if (!brandId || !groupId) {
            throw !brandId ? 'no brandId!' : 'no groupId!';
        }

        _protected.request("brands/" + brandId + "/settings/financial_unit_groups/" + groupId + "/remove/validate", "POST")
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createNewShareTransferGroup = function (brandId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "no brandId!";
        }

        _protected.request("brands/" + brandId + "/settings/financial_unit_groups", "POST", payload)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.updateShareTransferGroup = function (brandId, groupId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "no brandId!";
        }

        _protected.request('brands/' + brandId + '/settings/financial_unit_groups/' + groupId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res);
                }
            });
        return deferred.promise;
    };

    self.deleteTransferShareGroup = function (brandId, groupId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "no brandId!";
        }

        _protected.request('brands/' + brandId + '/settings/financial_unit_groups/' + groupId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res);
                }
            });
        return deferred.promise;
    };

    self.deleteUserTipped = function (brandId, userId, payTypeId, positionCode, tippedId) {

        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!payTypeId) {
            throw "No pay type id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/positions/' + encodeURIComponent(encodeURIComponent(positionCode)) + '/tipped/' + tippedId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPayTypeDetails = function (brandId, userId, payTypeId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!payTypeId) {
            throw "No pay type id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId, 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPayTypeHistory = function (brandId, userId, includeDeleted) {

        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        var params = {
            include_deleted: includeDeleted
        };

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/history', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserPayRates = function (brandId, userId, payTypeId, positionCode, includeDeleted) {

        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!payTypeId) {
            throw "No pay type id";
        }

        var params = {
            include_deleted: includeDeleted
        };

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/positions/' + encodeURIComponent(encodeURIComponent(positionCode)) + '/pay_rates', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserApprovalPayRates = function (brandId, userId, positionCode, approvalStates) {

        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        var params = {
            approval_states: approvalStates
        };

        _protected.request('brands/' + brandId + '/users/' + userId + '/positions/' + positionCode + '/pay_rate_approvals', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createUserPayRates = function (brandId, userId, payTypeId, positionCode, payload, headers) {

        var deferred = $q.defer();
        headers ??= {};

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!payTypeId) {
            throw "No pay type id";
        }

        _protected.requestWithHeaders('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/positions/' + encodeURIComponent(encodeURIComponent(positionCode)) + '/pay_rates', 'POST', payload, headers)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.editUserPayRates = function (brandId, userId, payTypeId, positionCode, payRateId, payload, headers) {

        var deferred = $q.defer();
        headers ??= {};

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!payTypeId) {
            throw "No pay type id";
        }

        _protected.requestWithHeaders('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/positions/' + encodeURIComponent(encodeURIComponent(positionCode)) + '/pay_rates/' + payRateId, 'PUT', payload, headers)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.editPendingUserPayRates = function (brandId, userId, payRateId, payload) {

        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_rate_approvals/' + payRateId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.editPendingUserPositionDetails = function (brandId, userId, approvalId, payload) {

        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/brand_user_position_approvals/' + approvalId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.deleteUserPayRates = function (brandId, userId, payTypeId, positionCode, payRateId, headers) {

        var deferred = $q.defer();
        headers ??= {};

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!payTypeId) {
            throw "No pay type id";
        }

        _protected.requestWithHeaders('brands/' + brandId + '/users/' + userId + '/pay_types/' + payTypeId + '/positions/' + encodeURIComponent(encodeURIComponent(positionCode)) + '/pay_rates/' + payRateId, 'DELETE', {} , headers)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deletePendingUserPayRates = function (brandId, userId, payRateId) {

        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!payRateId) {
            throw "No pay type id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/pay_rate_approvals/' + payRateId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandEmployeeBankAccountDetails = function (brandId, userId) {

        var deferred = $q.defer();

        _protected
            .request('brands/' + brandId + '/users/' + userId + '/bank_accounts', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data.bank_accounts);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateBrandEmployeeBankAccountDetails = function (brandId, userId, bankAccountsDetails) {

        var deferred = $q.defer();

        _protected
            .request('brands/' + brandId + '/users/' + userId + '/bank_accounts', 'PUT', bankAccountsDetails)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };



    self.getTeamMembersMaster = function (params) {
        var deferred = $q.defer();
        _protected.request('reports/brands/users', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getLocationsMappingUrl = function (brandId, params) {
        var defer = $q.defer();
        var url = 'brands/' + brandId + '/locations_mapping';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getCategoriesMappingUrl = function (brandId, params) {
        var defer = $q.defer();
        var url = 'brands/' + brandId + '/positions_categories_mapping';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getPositionsSkillLevels = function (brandId) {

        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/positions/skill_levels', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getIsNeManager = function (brandId, userId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/ne_manager', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateIsNeManager = function (brandId, userId, isNEManager) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var payload = isNEManager;

        _protected.request('brands/' + brandId + '/users/' + userId + '/ne_manager', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getTimedCardNumber = function (brandId, userId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/badge_id', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateTimedCardNumber = function (brandId, userId, timedCardNumber) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/badge_id', 'PUT', timedCardNumber)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.reactivateMember = function (brandId, memberId) {

        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/users/" + memberId + "/reactivate", "POST", {})
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getBrandUserPins = function(){
        var deferred = $q.defer();

        _protected.request("users/brands/pins", "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.employmentPeriods = function (brandId, memberId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "no brandId!";
        }

        if (!memberId) {
            throw "no memberId";
        }

        _protected.request("brands/" + brandId + "/users/" + memberId + "/employment_periods", "GET", {})
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getUserVSLValue = function (brandId, userId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "no brandId!";
        }

        if (!userId) {
            throw "no user id";
        }

        _protected.request("brands/" + brandId + "/users/" + userId + "/vsls", "GET", {})
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.updateUserVSLValue = function (brandId, userId, vslValue) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "no brandId!";
        }

        if (!userId) {
            throw "no user id";
        }

        _protected.request("brands/" + brandId + "/users/" + userId + "/vsls", "PUT", vslValue)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getUserVSLHistory = function (brandId, userId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "no brandId!";
        }

        if (!userId) {
            throw "no user id";
        }

        _protected.request("brands/" + brandId + "/users/" + userId + "/vsls/history", "GET", {})
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getBrandVSLValues = function (userId, brandsIds) {
        var deferred = $q.defer();

        if (!userId) {
            throw "No user id";
        }
        ;

        var payLoad = brandsIds.length > 0 ? {brand_ids: brandsIds.join(",")} : {};

        _protected.request("brands/users/" + userId + "/vsls", "GET", payLoad)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.updateBrandVSLValues = function (userId, payLoad) {
        var deferred = $q.defer();

        if (!userId) {
            throw "No user id";
        }
        ;

        _protected.request("brands/users/" + userId + "/vsls", "PUT", payLoad)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    const [getWageMatrixSettings] = cacheService.cache(async (brandId) => {
        if (!brandId) {
            throw "No brand id";
        }
        const res = await _protected.request(`brands/${brandId}/wage_matrix_settings`, 'GET');
        if (res?.data?.data && res.data.status_code === 200) {
            return res.data.data;
        } else {
            throw res;
        }
    });

    self.getWageMatrixSettings = getWageMatrixSettings;

    const [getHourlyWageRules, restHourlyWageRules] = cacheService.cache(async (brandId) => {
        if (!brandId) {
            throw "No brand id";
        }
        const res = await _protected.request(`brands/${brandId}/settings/wage_rules`, 'GET');
        if (res?.data?.data && res.data.status_code === 200) {
            return res.data.data.wage_rules;
        } else {
            throw res;
        }
    });

    self.getHourlyWageRules = getHourlyWageRules;
    self.restHourlyWageRules = restHourlyWageRules;

    self.getAllWageRules = async (brandId, positionCode, payTypes) => {
        let params = {};
        if (positionCode) {
            params.position_codes = positionCode;
        }
        if (payTypes) {
            params.pay_types = payTypes;
        }

        const res = await _protected.request(`brands/${brandId}/wage_rules`, 'GET', params);
        if (res?.data?.data && res.status === 200) {
            return res.data.data;
        }
        throw res;
    };

    self.archiveHourlyWageRule = function (brandId, ruleId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        if (!ruleId) {
            throw "No rule id";
        }
        _protected.request('brands/' + brandId + '/settings/wage_rules/' + ruleId + '/archive', 'POST')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.unarchiveHourlyWageRule = function (brandId, ruleId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        if (!ruleId) {
            throw "No rule id";
        }
        _protected.request('brands/' + brandId + '/settings/wage_rules/' + ruleId + '/unarchive', 'POST')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createNewHourlyWageRule = function (brandId, payload) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/wage_rules', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.updateHourlyWageRule = function (brandId, ruleId, payload) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/wage_rules/' + ruleId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    }

    self.getPensionRules = function (brandId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/pension_rules', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.archivePensionRule = function (brandId, ruleId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        if (!ruleId) {
            throw "No rule id";
        }
        _protected.request('brands/' + brandId + '/pension_rules/' + ruleId + '/archive', 'POST')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.unarchivePensionRule = function (brandId, ruleId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        if (!ruleId) {
            throw "No rule id";
        }
        _protected.request('brands/' + brandId + '/pension_rules/' + ruleId + '/unarchive', 'POST')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createNewPensionRule = function (brandId, payload) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/pension_rules', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.updatePensionRule = function (brandId, ruleId, payload) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/pension_rules/' + ruleId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    }

    self.getChBrandEmployers = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw new Error('Brand id is required  ' + Date.now());
        }

        _protected.request("brands/" + brandId + "/admins", "GET")
            .then(function (res) {
                    if (res.data) {
                        deferred.resolve(res.data.data);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });
        return deferred.promise;
    };

    self.getWorkLimitResponses = async (brandId, userId, retrievalMode, includeDeleted) => {
        const params = {
            retrieval_mode: retrievalMode,
            include_deleted: includeDeleted
        };
        const response = await _protected.request(`brands/${brandId}/users/${userId}/work_limit_responses`, 'GET', params);
        if (response?.status === 200 && response?.data?.data) {
            return response.data.data.work_limit_responses;
        }
        throw response;
    };

    self.deleteWorkLimitResponse = async (brandId, userId, responseId) => {
        const response = await _protected.request(`brands/${brandId}/users/${userId}/work_limit_responses/${responseId}`, 'DELETE');
        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }
        throw response;
    }

    self.createWorkLimitResponse = async (brandId, userId, value, startDate) => {
        const payload = {
            work_limit_response: {
                value: value,
                start_date: startDate
            }
        }
        const response = await _protected.request(`brands/${brandId}/users/${userId}/work_limit_responses`, 'POST', payload);
        if (response?.status === 200 && response?.data?.data) {
            return response.data.data?.work_limit_response;
        }
        throw response;
    }

    self.updateWorkLimitResponse = async (brandId, userId, responseId, value, startDate) => {
        const payload = {
            work_limit_response: {
                value: value,
                start_date: startDate
            }
        }
        const response = await _protected.request(`brands/${brandId}/users/${userId}/work_limit_responses/${responseId}`, 'PUT', payload);
        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }
        throw response;
    }

    self.getEmployeeBusinesses = function () {
        var deferred = $q.defer();
        _protected.request("employees/businesses/brands", "GET")
            .then(function (res) {
                    if (res.data && res.data.data && res.data.data.brands) {
                        deferred.resolve(res.data.data.brands);
                    } else {
                        deferred.reject('no businesses found');
                    }
                },
                function (err) {
                    deferred.reject(err);
                });
        return deferred.promise;
    }

    self.getPositionsTips = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/positions/' + '/troncs', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updatePositionsTips = function (brandId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/positions/' + '/troncs', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getEmployeeLocations = function (brandId) {
        const deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request(`brands/${brandId}/users/locations`, 'GET')
            .then((res) => {
                if (res?.data?.data?.brands) {
                    deferred.resolve(res.data.data.brands);
                } else {
                    deferred.reject(res);
                }

            },(err) => {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getCoreHREmployeeAwareness = function (brandId, userId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/harri/users/' + userId + '/employment', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getCoreHRBulkEmployeeAwareness = (brandId, userIds) => {
        const deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userIds) {
            throw "No user ids";
        }
        const harri_user_ids = userIds.join(',');
        const payload = {harri_user_ids: harri_user_ids};
        payload['limit'] = 100;

        _protected.request(`brands/${brandId}/harri/users/employments`, 'GET', payload)
            .then((res) => {
                if (res?.data?.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch((err) => {
                deferred.reject(err);
            });


        return deferred.promise;
    };
};

TeamAPI.PAYROLL_SYNC_TYPE = {
    PERSONAL_INFO: "PERSONAL_INFO",
    WAGE_DETAILS: "WAGE_DETAILS"
};

TeamAPI.APPROVAL_STATUS_CODES = {
    ACTIVE: 'ACTIVE',
    APPROVED: 'APPROVED',
    PENDING: 'PENDING',
    REJECTED: 'REJECTED',
    SCHEDULED: 'SCHEDULED'
}

TeamAPI.BRAND_COUNTRY_CODES = {
    UK: 'UK',
    US: 'US'
}